import { BarChartData } from 'src/components/shared/UtilizationBarGraph';
import { Maybe, GetSessionsConsumptionForExtendResponse } from 'src/@types';

const hours = [
  '00',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
];

export const getGraphData = (
  data: Maybe<GetSessionsConsumptionForExtendResponse> | undefined,
  timePeriod: number,
): BarChartData[] => {
  const timeSeries = data?.timeSeries || [];
  const barGraphData: BarChartData[] = hours.map((hour) => ({
    label: hour,
    value: 0,
  }));

  timeSeries.forEach((value) => {
    const hour = value?.timestamp?.substring(11, 13);
    barGraphData[parseInt(hour)].value += (value?.totalSessions || 0) / timePeriod;
  });

  return barGraphData;
};
